module.exports = __webpack_public_path__ + "static/media/gradient-star.80dd1ea6.gif";